import useSWRImmutable from 'swr/immutable';

import { kaGradeTabListApi } from '@service';
import { extractResponseData } from '@untils/request';

export function useKaGradeList() {
  return useSWRImmutable('/shop/ka/ka-grade-tab', () => kaGradeTabListApi().then(extractResponseData));
}
